export default __webpack_public_path__ + "static/job-summary-cd71cc8c9cf8d875a8b784b6c8383285.png";